import _ from 'lodash'
import $ from 'jquery'
import dompurify from 'dompurify'

var freeze = Object.freeze
if (!freeze) {
  freeze = function (x) {
    return x
  }
}

function allowTargetIfRel(node, hookEvent) {
  if (hookEvent.attrName !== 'target'  || node.tagName.toLowerCase() !== 'a') {
    return
  }
  if (hookEvent.attrValue === '_blank'
    && (node.rel === 'noopener noreferrer' || node.rel === 'noreferrer noopener')) {
    hookEvent.forceKeepAttr = true
  }
}

var allowTargetIfLocal = (function () {
  if (!window.location.origin) {
    console.log('allowTargetIfLocal disabled: no "origin" property' +
      'found in window.location or property empty')
    return function (node, hookEvent) {
      return
    }
  }
  var pagePrefix = window.location.origin + ctx
  return function (node, hookEvent) {
    if (hookEvent.attrName !== 'target' || node.tagName.toLowerCase() !== 'a') {
      return
    }
    var _href = node.href
    if (_href && _href.indexOf(pagePrefix) === 0 &&
      (pagePrefix.length === _href.length || _href[pagePrefix.length] === '/')) {
      hookEvent.forceKeepAttr = true
    }
  }
})();

function doPurify(text, options) {
  if (!_.isEmpty(text)) {
    var opts = $.extend({
      SAFE_FOR_JQUERY: true,
      FORCE_BODY: true,
    }, options || {
      ALLOW_TARGET_IF_LOCAL: true,
      ALLOW_TARGET_IF_REL: true,
    })
    if (opts.ALLOW_TARGET_IF_LOCAL) {
      dompurify.addHook('uponSanitizeAttribute', allowTargetIfLocal);
    }
    if (opts.ALLOW_TARGET_IF_REL) {
      dompurify.addHook('uponSanitizeAttribute', allowTargetIfRel);
    }

    text = dompurify.sanitize(text, opts)

    if (opts.ALLOW_TARGET_IF_REL) {
      dompurify.removeHook('uponSanitizeAttribute');
    }
    if (opts.ALLOW_TARGET_IF_LOCAL) {
      dompurify.removeHook('uponSanitizeAttribute');
    }
    if (dompurify.removed.length > 1) {
      console.log('dompurify.js: removed the following elements/attributes ' +
        '[' + window.location + ']:')
      var removed = dompurify.removed.slice(1);
      console.log(removed);
      try {
        _(removed).each(function (x) {
          if ('attribute'in x) {
            console.log('dompurify.js: detailed: attribute: ' + x.attribute.name);
          } else if ('element'in x) {
            console.log('dompurify.js: detailed: element: ' + x.element);
          } else {
            console.log('dompurify.js: detailed: ' + x);
          }
        });
      } catch (e) {}
    }
  }
  return text
}

var BLOCKS_FORMAT_LINK = freeze({
  ALLOWED_TAGS: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'blockquote',
    'b', 'i', /*'font',*/'s', 'u', 'o', 'sup', 'sub', 'ins', 'del', 'strong', 'strike', 'tt',
    'code', 'big', 'small', 'br', 'span', 'em', 'a', 'body',
  ],
  ALLOWED_ATTR: ['class', 'href', 'rel'],
  ALLOW_TARGET_IF_LOCAL: true,
  ALLOW_TARGET_IF_REL: true,
})

var IN_BUTTON = freeze({
  ALLOWED_TAGS: ['span', 'i', 'body'],
  ALLOWED_ATTR: ['class', 'aria-hidden'],
})

var purify = {
  run: doPurify,
  block: (x) => doPurify(x, BLOCKS_FORMAT_LINK),
  button: (x) => doPurify(x, IN_BUTTON),
}

export { purify as default }
